/**
 * Task 151-B — per-service config section dispatcher. Bridges the
 * drawer's opaque raw `config` object and the typed per-kind sections:
 * it normalizes raw→typed for display and serializes typed→raw (with the
 * `kind` discriminator re-attached) on every edit, so the drawer state
 * stays a plain JSON object ready for the 151-A `config jsonb`.
 */

import type { PackageServiceType } from '@kmi/contracts';
import { normalizeConfig, serializeConfig } from '../packageServiceConfigModel';
import {
  AdsSection,
  BrandSection,
  ContentSection,
  InfluencerSection,
  ProductionSection,
  SocialSection,
} from './sections';

export function ServiceConfigSection({
  kind,
  config,
  onChange,
  disabled,
}: {
  readonly kind: PackageServiceType;
  readonly config: Record<string, unknown>;
  readonly onChange: (nextRaw: Record<string, unknown>) => void;
  readonly disabled?: boolean;
}) {
  switch (kind) {
    case 'social':
      return (
        <SocialSection
          cfg={normalizeConfig('social', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('social', next))}
        />
      );
    case 'ads':
      return (
        <AdsSection
          cfg={normalizeConfig('ads', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('ads', next))}
        />
      );
    case 'influencer':
      return (
        <InfluencerSection
          cfg={normalizeConfig('influencer', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('influencer', next))}
        />
      );
    case 'production':
      return (
        <ProductionSection
          cfg={normalizeConfig('production', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('production', next))}
        />
      );
    case 'content':
      return (
        <ContentSection
          cfg={normalizeConfig('content', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('content', next))}
        />
      );
    case 'brand':
      return (
        <BrandSection
          cfg={normalizeConfig('brand', config)}
          disabled={disabled}
          onChange={(next) => onChange(serializeConfig('brand', next))}
        />
      );
    default:
      return null;
  }
}
